import React, { useEffect, useState, useRef } from 'react';
import { getregister, getmyprofile, getcaste, getdistrictslist, horoscoperequest } from "../action/user";
import { useLocation } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import swal from "sweetalert";
import FavoriteIcon from '@mui/icons-material/Favorite';
import config from "../../lib/config";
import { Button, MenuItem } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";

function Freesearch() {

    const history = useNavigate();
    const location = useLocation();
    const [userValue, setUserValue] = useState([]);
    // Create ref for file input
    const fileInputRef = useRef(null);

    const search = useLocation().search;
    const [searchparamsf, setsearchparamsf] = useState(search);
    // Image upload states
    const [jathagamPics, setJathagamPics] = useState([]);
    const [jathagamPreviews, setJathagamPreviews] = useState([]);

    var filterobj = "status=1";
    const castename = new URLSearchParams(search).get('castename');
    if (castename) {
        filterobj += "&castename=" + castename;
    }
    const religion = new URLSearchParams(search).get('religion');
    if (religion) {
        filterobj += "&religion=" + religion;
    }
    const subcaste = new URLSearchParams(search).get('subcaste');
    if (subcaste) {
        filterobj += "&subcaste=" + subcaste;
    }
    const sex = new URLSearchParams(search).get('sex');
    if (sex) {
        filterobj += "&sex=" + sex;
    }
    const maritalname = new URLSearchParams(search).get('maritalname');
    if (maritalname) {
        filterobj += "&maritalname=" + maritalname;
    }

    const c_date = new Date();
    let year = c_date.getFullYear();
    const age1 = new URLSearchParams(search).get('age1');
    if (age1) {
        const g_year = year - age1;
        filterobj += "&year[$lte]=" + g_year;
    }
    const age2 = new URLSearchParams(search).get('age2');
    if (age2) {
        const l_year = year - age2;
        filterobj += "&year[$gte]=" + l_year;
    }
    const [castes, setCastes] = useState([]);
    const getUserData = async () => {
        var test = await getmyprofile();
        setUserValue(test.userValue);
    }
    useEffect(() => {
        //logout(history)
        getUserData();
    }, []);
    const initialFormValue = {
        sex: "",
        horoscopeType: "",
        dob: "",
        time_of_birth: "",
        agent: "",
        description: ""
    };
    const [formValue, setFormValue] = useState(initialFormValue);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);
    const sexch = [
        { title: "Male", value: "Male" },
        { title: "Female", value: "Female" },
    ];

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValue(prev => ({ ...prev, [name]: value }));
    };

    // Handle multiple image upload with limit of 3
    const handleJathagamPicChange = (e) => {
        const files = Array.from(e.target.files);


        // Check if total files exceed 3
        if (jathagamPics.length + files.length > 3) {
            swal("Error", "You can only upload a maximum of 3 images", "error");
            // Clear the input
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            return;
        }


        // Validate file types
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        const invalidFiles = files.filter(file => !validTypes.includes(file.type));


        if (invalidFiles.length > 0) {
            swal("Error", "Please upload only image files (JPEG, JPG, PNG, GIF)", "error");
            // Clear the input
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            return;
        }


        // Update files
        setJathagamPics(prev => [...prev, ...files]);


        // Create preview URLs
        files.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setJathagamPreviews(prev => [...prev, reader.result]);
            };
            reader.readAsDataURL(file);
        });

        // Clear the input so same file can be selected again if needed
        e.target.value = '';
    };

    // Remove image from upload
    const removeJathagamPic = (index) => {
        setJathagamPics(prev => prev.filter((_, i) => i !== index));
        setJathagamPreviews(prev => prev.filter((_, i) => i !== index));
    };

    const [validateError, setValidateError] = useState({});
    const [districts, setDistricts] = useState([]);

    const horoscopeTypes = [
        { value: "Matchmaking", label: "Matchmaking" },
        { value: "Life", label: "Life" },
        { value: "Individual", label: "Individual" },
    ];

    const agents = [
        { value: "Select Agent", label: "Select Agent" },
        { value: "KS001 - Rajesh Kumar", label: "KS001 - Rajesh Kumar" },
        { value: "KS002 - Priya Sharma", label: "KS002 - Priya Sharma" },
        { value: "KS003 - Arun Patel", label: "KS003 - Arun Patel" },
        { value: "KS004 - Sneha Reddy", label: "KS004 - Sneha Reddy" },
        { value: "KS005 - Vikram Singh", label: "KS005 - Vikram Singh" },
    ];

    useEffect(() => {
        const fetchData = async () => {
            const d = await getdistrictslist();
            const disOpts = d.userValue?.map(d => ({ title: d.city, value: d._id }));
            setDistricts(disOpts);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (location.state?.selectedAgent) {
            setFormValue(prev => ({
                ...prev,
                agent: location.state.selectedAgent.value
            }));
        }
    }, [location.state]);

    const handleSubmit = async () => {
        // Validate required fields
        const errors = {};
        if (!formValue.horoscopeType) {
            errors.horoscopeType = "Horoscope type is required";
        }
        // if (!formValue.agent) {
        //     errors.agent = "Please select an agent";
        // }
        if (!formValue.description) {
            errors.description = "Description is required";
        }

        if (Object.keys(errors).length > 0) {
            setValidateError(errors);
            return;
        }

        setValidateError({});
        // Prepare data for API
        const requestData = {
            userno: userValue?.userno || userValue?.user_id || userValue?._id,
            user_id: userValue?._id,
            fullname: userValue?.mname,
            email: userValue?.email_id,
            phone: userValue?.mobile_number,
            city: userValue?.city || userValue?.district || "", // Adjust based on your user object
            requestedfor: formValue.horoscopeType,
            dob: formValue.dob,
            time_of_birth: formValue.time_of_birth,
            requesteddesc: formValue.description,
            jathagampic: jathagamPics // Pass the array of File objects
        };

        try {
            const response = await horoscoperequest(requestData);
            if (response.error) {
                swal("Error", response.error, "error");
            } else {
                swal("Success", response?.message, "success");
                // Clear form
                setFormValue(initialFormValue);
                setJathagamPics([]);
                setJathagamPreviews([]);

                // Clear file input using ref
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
            }
        } catch (error) {
            console.error("Submit error:", error);
            swal("Error", "Failed to submit request. Please try again.", "error");
        }
    };

    return (
        <div style={{ marginTop: '30px' }}>
            <h2 className="font-great-vibes" style={{ margin: '0px 20px', color: '#B21919' }}>
                Request for Horoscope
            </h2>

            <div style={{ maxWidth: 800, margin: "0 auto", padding: 20 }}>
                {/* <div style={{ margin: "1em 0", textAlign: "right" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => history(`/agent/list`)}
                        style={{
                            padding: "14px",
                            fontSize: "1.4rem",
                            fontWeight: "bold",
                            borderRadius: "6px",
                            background: "#B21919",
                            color: "#FFFFFF",
                        }}
                    >
                        Agents List
                    </Button>
                </div> */}

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Full Name"
                        name="mname"
                        value={userValue?.mname || ""}
                        disabled
                        variant="filled"
                        InputLabelProps={{
                            style: { fontSize: '16px' }
                        }}
                        InputProps={{
                            style: { fontSize: '16px', color: '#353535ff' }
                        }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Email"
                        type="email"
                        name="email_id"
                        value={userValue?.email_id || ""}
                        disabled
                        variant="filled"
                        InputLabelProps={{
                            style: { fontSize: '16px' }
                        }}
                        InputProps={{
                            style: { fontSize: '16px', color: '#353535ff' }
                        }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Mobile Number"
                        name="mobile_number"
                        value={userValue?.mobile_number || ""}
                        disabled
                        variant="filled"
                        InputLabelProps={{
                            style: { fontSize: '16px' }
                        }}
                        InputProps={{
                            style: { fontSize: '16px', color: '#353535ff' }
                        }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        select
                        label={
                            <span>
                                Horoscope Type <span style={{ color: '#ff0000', marginLeft: '2px' , fontSize:"16px"}}>*</span>
                            </span>
                        }
                        name="horoscopeType"
                        value={formValue.horoscopeType || ""}
                        onChange={handleChange}
                        error={!!validateError.horoscopeType}
                        helperText={validateError.horoscopeType}
                        variant="standard"
                        InputLabelProps={{
                            shrink: true,
                            style: {
                                fontSize: '16px',
                                color: '#000000',
                                textAlign: "left"
                            }
                        }}
                        InputProps={{
                            style: {
                                fontSize: '16px',
                                color: '#000000',
                                textAlign: "left"
                            }
                        }}
                        SelectProps={{
                            style: {
                                marginTop: "22px",
                                textAlign: "left"
                            }
                        }}
                    >
                        {horoscopeTypes.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>

                {formValue.horoscopeType === "Individual" && (
                    <div style={{ display: 'flex', gap: '20px', margin: "1em 0" }}>
                        <TextField
                            fullWidth
                            label="Date of Birth"
                            type="date"
                            name="dob"
                            value={formValue.dob || ""}
                            onChange={handleChange}
                            variant="standard"
                            InputLabelProps={{
                                shrink: true,
                                style: { fontSize: '16px', color: '#000000' }
                            }}
                            InputProps={{ style: { fontSize: '16px', color: '#000000' } }}
                        />
                        <TextField
                            fullWidth
                            label="Time of Birth"
                            type="time"
                            name="time_of_birth"
                            value={formValue.time_of_birth || ""}
                            onChange={handleChange}
                            variant="standard"
                            InputLabelProps={{
                                shrink: true,
                                style: { fontSize: '16px', color: '#000000' }
                            }}
                            InputProps={{ style: { fontSize: '16px', color: '#000000' } }}
                        />
                    </div>
                )}

                {/* <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        select
                        label="Select Agent"
                        name="agent"
                        value={formValue.agent || ""}
                        onChange={handleChange}
                        error={!!validateError.agent}
                        helperText={validateError.agent}
                        variant="standard"
                        InputLabelProps={{
                            shrink: true,
                            style: {
                                fontSize: '16px',
                                color: '#000000',
                                textAlign: "left"
                            }
                        }}
                        InputProps={{
                            style: {
                                fontSize: '16px',
                                color: '#000000',
                                textAlign: "left"
                            }
                        }}
                        SelectProps={{
                            style: {
                                marginTop: "22px",
                                textAlign: "left"
                            }
                        }}
                    >
                        {agents.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </div> */}

                <div style={{ margin: "2em 0" }}>
                    <label style={{
                        display: 'flex',
                        fontSize: '16px',
                        color: '#000000',
                        marginBottom: '8px',
                        fontWeight: '500'
                    }}>
                        Horoscope Pictures (Max 3)
                    </label>


                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleJathagamPicChange}
                        disabled={jathagamPics.length >= 3}
                        style={{
                            display: 'flex',
                            marginBottom: '10px',
                            fontSize: '14px'
                        }}
                    />


                    <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                        {jathagamPics.length}/3 images uploaded
                    </div>


                    {/* Image Previews */}
                    {jathagamPreviews.length > 0 && (
                        <div style={{
                            display: 'flex',
                            gap: '10px',
                            flexWrap: 'wrap',
                            marginTop: '10px'
                        }}>
                            {jathagamPreviews.map((preview, index) => (
                                <div
                                    key={index}
                                    style={{
                                        position: 'relative',
                                        width: '150px',
                                        height: '150px',
                                        border: '1px solid #ddd',
                                        borderRadius: '4px',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <img
                                        src={preview}
                                        alt={`Jathagam ${index + 1}`}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <button
                                        onClick={() => removeJathagamPic(index)}
                                        style={{
                                            position: 'absolute',
                                            top: '5px',
                                            right: '5px',
                                            background: '#B21919',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '50%',
                                            width: '25px',
                                            height: '25px',
                                            cursor: 'pointer',
                                            fontSize: '16px',
                                            lineHeight: '1',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div style={{ margin: "1em 0" }}>
                    <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        value={formValue.description || ""}
                        onChange={handleChange}
                        error={!!validateError.description}
                        helperText={validateError.description}
                        variant="standard"
                        multiline
                        rows={4}
                        InputLabelProps={{
                            shrink: true,
                            style: { fontSize: '16px' }
                        }}
                        InputProps={{
                            style: { fontSize: '16px', color: '#353535ff' }
                        }}
                    />
                </div>

                <div style={{ margin: "1em 0" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        fullWidth
                        style={{
                            padding: "14px",
                            fontSize: "1.4rem",
                            fontWeight: "bold",
                            borderRadius: "6px",
                            background: "#B21919",
                            color: "#FFFFFF"
                        }}
                    >
                        Request Horoscope
                    </Button>
                </div>
            </div>
        </div>
    )
}


export default Freesearch;
